import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ReportHistoryFilterService {
  constructor(private datepipe: DatePipe) { }

  filterData(dataList: any[], filter: any): any[] {
    if (dataList && filter && dataList.length > 0) {
      const filterKeys = Object.keys(filter);
      if (filterKeys && filterKeys.length > 0) {
        filterKeys.forEach((value) => {
          dataList = dataList.filter(item => {
            let match = false;

            let columnValue = item[value];
            const columnFilter = filter[value];

            // convert dates
            if (columnValue instanceof Date) {
              columnValue = this.datepipe.transform(columnValue, 'MM/dd/yyyy', 'UTC');
            }

            if (columnValue && columnFilter) {
              // toString() converts numbers and dates so we can do compares
              match = columnValue.toString().toLowerCase().includes(columnFilter.toString().toLowerCase());
            } else if (!columnFilter) {
              match = true;
            }

            return match;
          });
        });
      }
    }

    return dataList;
  }
}
